import BaseAbility from 'umg-ember-backend/abilities/base';

export default class NewsletterConfigAbility extends BaseAbility {
  get permissions() {
    return this.permission.for('artist');
  }
}
